import { extensions } from '@yola/ws-sdk';
import config from '../constants/config';

const isBusinessLogo = (element) => {
  if (!element) return false;

  const settings = extensions.accessors.getExtensionSettings(config.slug);

  return Boolean(element.closest(settings.businessLogoSelector));
};

export default isBusinessLogo;
